/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useRef, useEffect } from 'react';
import { Form, Formik } from 'formik';
import { Button, Popover, PopoverBody } from 'reactstrap';

const AdvancedFilters = ({
  handleFilters,
  initialValues,
  children,
  id = 'filter',
  PositionTop = '0',
  PositionLeft = '0',
  placement = 'auto',
  sidePreference = 'left',
  minSideSpace = 280,
  minVerticalSpace = 240,
  toggleAdvancedSearchBar = () => {},
}) => {
  const [showFilters, setShowFilters] = useState(false);
  const [popoverPlacement, setPopoverPlacement] = useState(
    placement === 'auto' ? 'bottom' : placement,
  );
  const popoverRef = useRef(null);
  const contentRef = useRef(null);
  const togglePopover = () => {
    setShowFilters(!showFilters);
  };

  const handleSubmit = (values) => {
    handleFilters(values);
    setShowFilters(false);
    toggleAdvancedSearchBar();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setShowFilters(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (placement !== 'auto') {
      setPopoverPlacement(placement);
      return;
    }

    if (!showFilters) return;

    const buttonEl = document.getElementById(id);
    if (!buttonEl) {
      setPopoverPlacement('bottom');
      return;
    }

    const rect = buttonEl.getBoundingClientRect();
    const space = {
      left: rect.left,
      right: window.innerWidth - rect.right,
      top: rect.top,
      bottom: window.innerHeight - rect.bottom,
    };

    let nextPlacement = 'bottom';

    const canFitLeft = space.left >= minSideSpace;
    const canFitRight = space.right >= minSideSpace;
    const canFitTop = space.top >= minVerticalSpace;
    const canFitBottom = space.bottom >= minVerticalSpace;

    const isRightTight = space.right < minSideSpace;
    const isLeftTight = space.left < minSideSpace;

    if (sidePreference === 'left' && canFitLeft && isRightTight) {
      nextPlacement = 'left';
    } else if (sidePreference === 'right' && canFitRight && isLeftTight) {
      nextPlacement = 'right';
    } else if (canFitBottom) {
      nextPlacement = 'bottom';
    } else if (canFitTop) {
      nextPlacement = 'top';
    } else if (sidePreference === 'left' && canFitLeft) {
      nextPlacement = 'left';
    } else if (sidePreference === 'right' && canFitRight) {
      nextPlacement = 'right';
    }

    setPopoverPlacement(nextPlacement);
  }, [
    showFilters,
    placement,
    sidePreference,
    id,
    minSideSpace,
    minVerticalSpace,
  ]);

  const handleContentClick = (event) => {
    event.stopPropagation();
  };

  return (
    <div
      ref={popoverRef}
      className="d-inline-block advance-filter position-absolute"
      style={{ left: PositionLeft, marginTop: PositionTop }}
    >
      <Button
        color="link"
        id={id}
        className="p-0 text-decoration-underline text-primary f-12 filter-btn"
        onClick={togglePopover}
      >
        Advance Search
        {/* <BsFilter /> */}
      </Button>
      <Popover
        placement={popoverPlacement}
        isOpen={showFilters}
        target={id}
        toggle={togglePopover}
      >
        <div ref={contentRef} onClick={handleContentClick}>
          {/* <PopoverHeader>Filters</PopoverHeader> */}
          <PopoverBody>
            <Formik
              initialValues={initialValues}
              onSubmit={handleSubmit}
              children={(formProps) => {
                return (
                  <Form onSubmit={formProps.handleSubmit}>
                    <div className="filter-row">
                      {' '}
                      {children} {/* <div className="text-end mt-1"> */}
                      <div className="text-end">
                        <Button
                          color="primary"
                          size="sm"
                          type="submit"
                          disabled={
                            !formProps?.isValid ||
                            !formProps?.dirty ||
                            formProps?.isSubmitting
                          }
                        >
                          Search
                        </Button>
                      </div>
                      {/* </div> */}
                    </div>
                  </Form>
                );
              }}
            />
          </PopoverBody>
        </div>
      </Popover>
    </div>
  );
};

export default AdvancedFilters;
